import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './views/HomePage.vue';
import RsvpListComponent from './components/rsvp-list/RsvpListComponent.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  { path: '/thaobi', component: RsvpListComponent }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;